import React, { useRef, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Mail, Phone, MapPin, Send, ChevronRight, MessageCircle, Clock, Globe } from 'lucide-react';
import ContactForm from '../components/Contactform';
import ContactInfo from '../components/ContactInfo';
import LeafletMap from '../components/Map/Map';

const businessData = [
  {
    name: "Data Center Business",
    email: "datacenter@bhagwatiproductsltd.com",
    phone: "+91 9999 111 111",
    locations: "Noida - Uttar Pradesh, Hyderabad - Telangana",
  },
  {
    name: "Software Business",
    email: "software@bhagwatiproductsltd.com",
    phone: "+91 9999 222 222",
    locations: "Bangalore - Karnataka, Pune - Maharashtra",
  },
  {
    name: "Automotive Electronics Business",
    email: "automotive@bhagwatiproductsltd.com",
    phone: "+91 9999 333 333",
    locations: "Rudrapur - Uttarakhand, Bhiwadi - Rajasthan",
  },
];

export default function ContactPage() {
  const [activeTab, setActiveTab] = useState(0);
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end start"]
  });

  const y = useTransform(scrollYProgress, [0, 1], [0, -300]);

  return (
    <div ref={containerRef} className="relative bg-gray-50 text-gray-900 overflow-hidden">
      {/* Hero Section with Parallax */}
      <div className="relative h-[70vh] flex items-center justify-center">
        <motion.div 
          style={{ y }}
          className="absolute inset-0 overflow-hidden"
        >
          <div className="absolute inset-0 bg-gradient-to-b from-orange-500/10 to-white/80 mix-blend-multiply" />
          <img
            src="/placeholder.svg"
            alt="Contact Hero Background"
            className="w-full h-full object-cover scale-110"
          />
        </motion.div>
        
        <div className="relative z-10 text-center px-4">
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.5, ease: "easeOut" }}
          >
            <h1 className="text-6xl md:text-9xl font-bold tracking-tighter mb-6">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-600 to-yellow-500">
                Get In Touch
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-700 max-w-2xl mx-auto">
              We're here to help and answer any questions you might have
            </p>
          </motion.div>
        </div>
      </div>

      {/* Quick Contact Banner */}
      <div className="relative z-10 -mt-16 px-4">
        <div className="container mx-auto">
          <div className="bg-white rounded-xl shadow-xl p-8 grid grid-cols-2 md:grid-cols-4 gap-8">
            {[
              { icon: Phone, label: "Call Us", value: "+91 9999 000 000" },
              { icon: Mail, label: "Email Us", value: "contact@bhagwati.com" },
              { icon: MessageCircle, label: "Live Chat", value: "Available 24/7" },
              { icon: Clock, label: "Business Hours", value: "Mon-Fri: 9AM-6PM" }
            ].map((contact, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="text-center"
              >
                <contact.icon className="w-8 h-8 mx-auto mb-4 text-orange-500" />
                <p className="text-sm font-medium text-gray-600">{contact.label}</p>
                <p className="text-lg font-bold text-gray-900">{contact.value}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-24">
        <div className="grid md:grid-cols-2 gap-16">
          {/* Contact Form */}
          <ContactForm />

          {/* Contact Information */}
          <ContactInfo businessData={businessData} activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>
      </div>

      {/* Map Section */}
      <LeafletMap />

     
    </div>
  );
}
